import * as React from 'react';
import { graphql } from 'gatsby';
import {
  BuilderComponent,
  withChildren,
  Builder,
  BuilderBlocks
} from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Helmet } from 'react-helmet';
import Link from '../components/Link/Link';
import '@builder.io/widgets';

const defaultTitle = 'Sellox | Home for businesses in Africa';
const defaultDescription = 'Edit this in your entry for a better SEO';


function LandingPageTemplate({ location, data: _data }) {
  const models = _data?.allBuilderModels;
  const landingPage = models.page[0]?.content;

  const data = landingPage?.data;
  const metaTags = [
    { itemprop: 'name', content: data.title },
    { itemprop: 'description', content: data.description },
    { name: 'description', content: data.description },

    { property: 'og:title', content: data.title },
    { property: 'og:description', content: data.description },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: data.image || 'https://firebasestorage.googleapis.com/v0/b/sellox-prod.appspot.com/o/Yellow%20and%20Blue%20Man%20Photography%20Safety%20Culture%20Twitter%20Post.png?alt=media&token=38e7fcc2-6856-4126-a514-03d702f59e8c' },

    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: data.title },
    { name: 'twitter:description', content: data.description }
  ]

  return (
    <>
      <Helmet
        title={data.title}
        meta={metaTags}
        htmlAttributes={{
          lang: 'en',
        }}>
      </Helmet>
      {/** name of the model is landing page, change it if you decided to build*/}
      <BuilderComponent
        renderLink={Link}
        name="page"
        content={landingPage}
      />
    </>
  );
}

export default LandingPageTemplate;

export const landingPageQuery = graphql`
  query($path: String!) {
    allBuilderModels {
      page(
        target: { urlPath: $path }
        limit: 1
        options: { cachebust: true }
      ) {
        content
      }
    }
  }
`;
